import React from "react";
import ReactDOM from "react-dom/client";

import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.min.css";
import "primeicons/primeicons.css";
import "@idwal/idwal-react-components/css/idwal-theme.css";
import common_en from "@idwal/idwal-react-components/translations/en/common.json";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Authenticator } from "@aws-amplify/ui-react";
import { BrowserRouter } from "react-router-dom";

import app_locale_en from "./translations/en/locale.json";

import { I18nextProvider } from "react-i18next";
import i18next from "i18next";

import { CookiesProvider } from "react-cookie";

i18next.init({
    interpolation: { escapeValue: false },
    lng: "en",
    resources: {
        en: {
            common: common_en,
            locale: app_locale_en
        }
    }
});

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <React.StrictMode>
        <CookiesProvider>
            <I18nextProvider i18n={i18next}>
                <Authenticator.Provider>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </Authenticator.Provider>
            </I18nextProvider>
        </CookiesProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
